import React from 'react';

import { useRouter } from 'next/router';
import { thumbnailPropertySetter } from 'src/utils/analytics/mixpanel/propertySetter';
import {
  generateCardsUrl,
  navigationHandler
} from 'src/utils/cardsUrlGenerator';

import { useAppStore } from 'src/hooks/useAppStore';
import ThumbnailCTA from '../../components/ThumbnailCTA';
import ThumbnailImage from '../../components/ThumbnailImage';
import ThumbnailMetadata from '../../components/ThumbnailMetadata';
import { ShareItemProps, ThumbnailComponentProps } from '../../types';
import * as customStyled from './styles';

const Vertical: React.FC<ThumbnailComponentProps> = ({
  title,
  imageUrl,
  slug,
  overout,
  tags,
  thumbnailType,
  displayTitleOnImg,
  assetSubType,
  assetType,
  businessType,
  billingType,
  description,
  content,
  tagName,
  cardDetails,
  contentPartner,
  content_partner_details,
  joystickIconCheck,
  dataTestId,
  isCommerceItem = false,
  showHover,
  isSearchLanding = false
}) => {
  const router = useRouter();

  const { appConfig, usersLocationData } = useAppStore();
  const contentItemCard = customStyled.contentItemCard(overout, showHover);
  let slugData = content ? generateCardsUrl(content) ?? slug : '';
  if (slugData) {
    slugData = slugData.startsWith('/') ? slugData : `/${slugData}`;
  }
  //TODO: We can use global url helper to truncate the url
  if (appConfig?.isRequestedByBot && usersLocationData?.country_code !== 'IN') {
    const globalRegex = /\/global\//;
    slugData = slugData
      .replace(globalRegex, '/')
      .replace(`/${router.locale}/`, '/');
  }

  const shareItems: ShareItemProps = {
    title,
    slug: slugData,
    assetSubType,
    assetType,
    description
  };

  const watchCallback = (e: any) => {
    window.storeMixPanelMetricsInSS('CLICKED_EVT', Date.now());
    e.preventDefault();
    if (slugData) {
      const eventTitle = isSearchLanding ? cardDetails?.title : title;
      thumbnailPropertySetter({
        item: {
          title: eventTitle,
          imageUrl,
          assetSubType,
          businessType,
          billingType,
          tags,
          link: slug,
          contentPartner,
          content_partner_details,
          isSearchLanding,
          cardDetails
        }
      });
      navigationHandler(slugData, (slugData) => {
        if (content?.asset_type === 6) {
          window.location.href = slugData;
        } else {
          router.push(slugData, slugData);
        }
      });
    }
  };

  return (
    <div
      title={title}
      className="keen-slider__slide"
      css={customStyled.container(overout)}
      data-testid={dataTestId}>
      <article css={contentItemCard}>
        <ThumbnailImage
          imageUrl={imageUrl}
          slug={slugData}
          assetType={assetType}
          title={title}
          businessType={businessType}
          billingType={billingType}
          onClickHandler={watchCallback}
          tagName={tagName}
          thumbnailType={thumbnailType}
          contentPartner={contentPartner}
          content_partner_details={content_partner_details}
          joystickIconCheck={joystickIconCheck}
        />
        <div css={customStyled.contentItemPopUp} className="popup-content">
          <div>
            <h3 title={title}>
              <span>{title}</span>
            </h3>
            {tags?.length ? (
              <ThumbnailMetadata
                tags={tags}
                overout={overout}
                type="vertical"
              />
            ) : null}
            <ThumbnailCTA
              watchCallback={watchCallback}
              shareItems={shareItems}
              cardDetails={cardDetails}
            />
          </div>
        </div>
        {displayTitleOnImg ? (
          <div css={customStyled.thumbnailTitle}>{title}</div>
        ) : null}
      </article>
    </div>
  );
};

export default Vertical;
